class EstadosJuicio{
  constructor(id,descripcion)
  {
    
    this.id=id
    this.descripcion=descripcion
  }
}

export default EstadosJuicio